import { atIndexMaybe, isJust, mapMaybe, type Maybe } from "./maybe";
/** Translate a visible insertion boundary into the existing exact-slot API. */
export function storyboardInsertionSlot(
  scenes: readonly { file: string }[],
  sourceFile: string,
  before: Maybe<string>,
): Maybe<string> {
  if (isJust(before)) {
    const source = scenes.findIndex((scene) => scene.file === sourceFile);
    const target = scenes.findIndex((scene) => scene.file === before.value);
    if (source >= 0 && target > source) {
      return mapMaybe(atIndexMaybe(scenes, target - 1), (scene) => scene.file);
    }
  }
  return before;
}
